import { NotifyHelper } from "../../../helpers/toast";
import {  eTongHopToanKhoaActionsObj } from "../../action-types/tong-hop-diem/ITongHopToanKhoaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tongHopToanKhoaActions= {
    ...generateActions(eTongHopToanKhoaActionsObj, "TONG_HOP_TOAN_KHOA"),
    ...generateActionForKey(eTongHopToanKhoaActionsObj, "TONG_HOP_TOAN_KHOA", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    })
}